export default __webpack_public_path__ + "static/media/flower-6.695fd109.svg";